export enum Sex {
  MALE = 0,
  FEMALE = 1
}
